import React from 'react';

import { createIcon } from '../createIcon';

function SvgDown(props: React.SVGProps<SVGSVGElement>): React.JSX.Element {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <defs>
        <path
          d="M9.317 11.615l-.093.092a1.317 1.317 0 01-1.76-.094L2.777 6.905a1.279 1.279 0 010-1.812L7.464.385A1.31 1.31 0 019.22.295l.004-.004.093.092-.005.005c.412.506.38 1.242-.085 1.71l-3.884 3.9L9.227 9.9c.452.454.495 1.162.08 1.706l.01.009z"
          id="Down_svg__a"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h16v16H0z" />
        <g transform="translate(2 2)">
          <path d="M0 0h12v12H0z" />
          <use fill="currentColor" transform="rotate(-90 6 6)" xlinkHref="#Down_svg__a" />
        </g>
      </g>
    </svg>
  );
}

export const DownFilledIcon = createIcon(SvgDown, 'DownFilledIcon');
